<template>
  <div id="app">
    <router-view  v-wechat-title='$route.meta.title+title' />
  </div>
</template>

<script>
export default {
  name: 'App',
  data(){
    return{
      title:'-中国唐山应急产业大会'
    }
  }
}
</script>

<style>
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
}
</style>
